<div class="container">
  <div class="text-center">
    <h2>
      <strong class="mainHeading slide-in-left">Order Approval</strong>
    </h2>
  </div>

  <div class="card p-3">
    <div class="row g-3">
      <!-- First Select -->
      <div class="col-12 col-md-3">
        <label for="city" class="form-label mb-0">City</label>
        <select id="city" class="form-select" [(ngModel)]="selectedCity" (change)="onCityChange($event)">
          <option value="">All Cities</option>
          <option *ngFor="let city of cityList" [value]="city.id">
            {{ city.cityName }}
          </option>
        </select>
      </div>

      <!-- Second Select -->
      <div class="col-12 col-md-3">
        <label for="zone" class="form-label mb-0">Zone</label>
        <select id="zone" class="form-select" [(ngModel)]="selectedZone" (change)="onZoneChange($event)">
          <option value="">All Zones</option>
          <option *ngFor="let zone of zoneList" [value]="zone.zoneId">
            {{ zone.zoneName }}
          </option>
        </select>
      </div>

      <div class="col-12 col-md-3">
        <label for="fromDate" class="form-label mb-0">Date:</label>
        <input
          type="date"
          id="fromDate"
          [(ngModel)]="ngFromDate"
          (change)="onFromDateChange($event)"
          class="form-control"
        />
      </div>

      <div class="col-12 col-md-3">
        <button
          class="btn btn-primary mt-3"
          (click)="clearGrid()"
          ngbTooltip="Clear filter"
        >
          <span> <i class="bi bi-x-circle me-2"></i></span>Clear Filter
        </button>
      </div>

      <!-- To Date -->
      <!-- <div class="col-12 col-md-3">
        <label for="toDate" class="form-label mb-0">To Date:</label>
        <input
          type="date"
          id="toDate"
          (change)="onToDateChange($event)"
          [(ngModel)]="ngToDate"
          class="form-control"
          [disabled]="!isToDateShow"
        />
      </div> -->
    </div>

    <!-- Third Select -->
    <!-- <div class="col-12 col-md-4">
        <select class="form-select">
          <option value="">Select Option 3</option>
          <option>City</option>
        </select>
      </div> -->
  </div>
</div>

<!--------------------------------- Table --------------------------------->

<div class="card p-3 shadow-lg mt-3 slide-up">
  <!-- <div class="justify-content-start">
      <h5 class="fs-5 fw-bold">Order Details</h5>
    </div> -->
  <div class="table-responsive mt-2">
    <table
      class="table table-bordered table-striped table-hover"
      style="max-width: 100%; overflow-x: auto"
    >
      <thead>
        <tr>
          <th class="text-center">Order ID</th>
          <th class="text-center">Requestor Type</th>
          <th class="text-center">Requestor Name</th>
          <th class="text-center">Requestor mobile no</th>
          <th class="text-center">Order Created Date</th>
          <th class="text-center">Container Drop Request Date</th>
          <th class="text-center">No of trips</th>
          <th class="text-center">City</th>
          <th class="text-center">Order Status</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of pagedData; let i = index">
          <td
            (click)="openDetailModal(detailsModal, row)"
            class="custom-width pointer text-center custom-column-width"
          >
            <a class="hyperLink" style="color: #8e0e00">{{ row.orderId }}</a>
          </td>
          <td class="custom-width text-center">{{ row.requestorType }}</td>
          <td class="text-center">
            {{
              row.requestorType == "Individual Requester"
                ? row.requestorName
                : row.companyName
            }}
          </td>
          <td class="text-center">{{ row.requestorMobile }}</td>
          <td class="text-center custom-width">
            {{ row.requestDate | date : "dd MMM yyyy" }}
          </td>
          <td class="text-center custom-width">
            {{ row.scheduledDate | date : "dd MMM yyyy" }}
          </td>
          <td class="text-center custom-width">{{ row.noOfTotalTrips }}</td>
          <td class="text-center custom-width">{{ row.city }}</td>
          <td class="text-center" style="width: 13%; text-align: center">
            {{ row.currentOrderStatus }}
          </td>
          <td class="text-center" style="width: 20%; cursor: pointer">
            <span (click)="openDetailModal(detailsModal, row)">
              <a class="hyperLink" style="color: #8e0e00">Review & Approve</a>
              <span
                *ngIf="row.currentOrderStatusID >= '102'"
                class="d-flex align-items-center"
              >
                <span
                  class="status-dot text-center"
                  style="background-color: green"
                ></span>
                Sar Received
              </span>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      class="d-flex justify-content-center align-items-center text-center"
      *ngIf="pagedData?.length === 0"
    >
      <app-no-data-found></app-no-data-found>
    </div>
    <!-- Pagination -->
  </div>
  <div
    class="d-flex justify-content-between align-items-center mt-3 flex-wrap"
    *ngIf="pagedData?.length > 0"
  >
    <!-- Entries Select Box -->
    <div class="d-flex align-items-center mb-2 me-3">
      <label class="me-2 mb-0">Show</label>
      <select
        class="form-select text-center"
        style="width: auto"
        [(ngModel)]="pageSize"
        (change)="onPageChange(1)"
      >
        <option *ngFor="let size of pageSizeOptions" [value]="size">
          {{ size }}
        </option>
      </select>
      <label class="ms-2 mb-0">entries</label>
    </div>

    <!-- Pagination Centered -->
    <div class="d-flex justify-content-center flex-grow-1 mb-2">
      <ngb-pagination
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [collectionSize]="approveOrderList?.length"
        (pageChange)="onPageChange($event)"
        [maxSize]="3"
        [boundaryLinks]="true"
      >
      </ngb-pagination>
    </div>

    <!-- Entries Range Info Aligned Right -->
    <div *ngIf="approveOrderList?.length > 0" class="text-muted mb-2 text-end">
      <strong>
        Showing {{ (currentPage - 1) * pageSize + 1 }} to
        {{
          currentPage * pageSize > approveOrderList?.length
            ? approveOrderList?.length
            : currentPage * pageSize
        }}
        of {{ approveOrderList?.length }} entries
      </strong>
    </div>
  </div>
</div>

<!--------------------------------- Details popup --------------------------------->

<ng-template #detailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Order Details - ({{ selectedOrderId }})</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="orderForm">
    <div class="modal-body custom-modal">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="userType" class="form-label">Requestor Type</label>
          <input
            id="userType"
            formControlName="userType"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="companyName" class="form-label">Name</label>
          <input
            id="companyName"
            formControlName="companyName"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="mobileNumber" class="form-label">Mobile Number</label>
          <input
            id="mobileNumber"
            formControlName="mobileNumber"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="location" class="form-label">Location</label>
          <input
            id="location"
            formControlName="location"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="reqLat" class="form-label">Latitude</label>
          <input
            id="reqLat"
            formControlName="reqLat"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="reqLng" class="form-label">Longitude</label>
          <input
            id="reqLng"
            formControlName="reqLng"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="city" class="form-label">City</label>
          <input
            id="city"
            formControlName="city"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="zone" class="form-label">Zone</label>
          <input
            id="zone"
            formControlName="zone"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="reqDate" class="form-label"
            >Order Created Date & Time</label
          >
          <input
            id="reqDate"
            formControlName="reqDate"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="scheduledDate" class="form-label"
            >Container Drop Request Date & Time
          </label>
          <input
            id="scheduledDate"
            formControlName="scheduledDate"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="containerName" class="form-label">Container Type</label>
          <input
            id="containerName"
            formControlName="containerName"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="containerCapacity" class="form-label"
            >Container Capacity in ( m³ )</label
          >
          <input
            id="containerCapacity"
            formControlName="containerCapacity"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="containerCount" class="form-label"
            >No Of Containers</label
          >
          <input
            id="containerCount"
            formControlName="containerCount"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="rentalDuration" class="form-label"
            >Rental Duration (Weeks)</label
          >
          <input
            id="rentalDuration"
            formControlName="rentalDuration"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="totalTrip" class="form-label">Total Trips</label>
          <input
            id="totalTrip"
            formControlName="totalTrip"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="sar" class="form-label"
            >Total Estimated Qty as per EOC (m³)</label
          >
          <input id="sar" formControlName="qty" class="form-control" readonly />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label for="material" class="form-label">Material Type</label>
          <input
            id="material"
            formControlName="material"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-sm-6">
          <label for="reqType" class="form-label">Request Type</label>
          <input
            id="material"
            formControlName="requestType"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row mb-3">
        @if (requestType == 'NewConstruction') {
        <div class="col-sm-6">
          <label for="eocDoc" class="form-label"
            >Engineering Office Certificate(EOC) Document</label
          >
          <div class="d-flex align-items-center mt-2">
            <a
              id="eocDoc"
              download
              class="d-flex align-items-center hyperLink"
              (click)="viewEoc()"
            >
              <i class="fas fa-download me-2"></i>
              Click here to view the EOC document
            </a>
          </div>
        </div>
        }
      </div>

      <div class="d-flex align-items-center">
        <hr class="flex-grow-1" />
        <p class="mx-2 mb-0"><strong>Select the dumpyard</strong></p>
        <hr class="flex-grow-1" />
      </div>

      <div class="modal-body">
        <h4>Nearest Dumpyard :-</h4>
        <div *ngIf="dumpyardDistances.length > 0">
          <p>
            <strong>{{ dumpyardDistances[0].dumpyardName }}</strong> -
            {{ dumpyardDistances[0].distance }} km
          </p>
        </div>
        <hr />
        <h4>All Dumpyards</h4>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th class="text-center">S.No</th>
              <th class="text-center">Dumpyard Name</th>
              <th class="text-center">Distance (km)</th>
              <th class="text-center">Select</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let dump of dumpyardDistances; let i = index">
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ dump.dumpyardName }}</td>
              <td class="text-center">{{ dump.distance }}</td>
              <td class="text-center">
                <input
                  type="checkbox"
                  class="form-check-input fs-5"
                  [checked]="selectedDumpyardId === dump.dumpyardId"
                  [disabled]="
                    selectedDumpyardId && selectedDumpyardId !== dump.dumpyardId
                  "
                  (change)="onCheckboxChange(dump, $event)"
                />
              </td>
            </tr>
            @if(baldiaDumpyardList?.length == 0) {
            <tr>
              <td colspan="10" class="text-center">
                <strong>No Dumpyard Found</strong>
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="btn custom-confirm-btn"
        (click)="openConfirmationModal(confirmationModal)"
      >
        Approve
      </button>
      <button
        type="button"
        class="btn custom-confirm-btn"
        (click)="openReasonModal(reasonModal, 'deny')"
      >
        Deny
      </button>
      <button
        type="button"
        class="btn custom-confirm-btn"
        (click)="openReasonModal(reasonModal, 'resubmit')"
      >
        Re-Submit
      </button>
    </div>
  </form>
</ng-template>

<!--------------------------------- Confirm popup --------------------------------->

<ng-template #confirmationModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-2">Approve Order ({{ orderId }})</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <div class="modal-body">
    <p>
      Are you sure you want to approve the requester ({{
        selectedRequestorName
      }})?
    </p>

    <!-- File Upload Fields Start -->
    <div class="mb-3">
      <label for="uploadDocument" class="form-label">Upload Document</label>
      <input
        class="form-control"
        type="file"
        id="uploadDocument"
        (change)="onFileSelected($event)"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn custom-confirm-btn"
      (click)="approveOrder('Approve')"
    >
      Confirm
    </button>
    <button
      type="button"
      class="btn custom-cancel-btn"
      (click)="modal.dismiss('Cancel click')"
    >
      Cancel
    </button>
  </div>
</ng-template>

<!--------------------------------- Reason popup --------------------------------->

<ng-template #reasonModal let-modal>
  <form [formGroup]="reasonForm">
    <div class="modal-header custom-modal-header">
      <h4 class="modal-title mt-3">Enter Reason</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <textarea
        formControlName="reasonText"
        class="form-control"
        rows="4"
        placeholder="Type your reason here..."
      ></textarea>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-primary"
        (click)="approveOrder(isDeny ? 'deny' : 'resubmit')"
        [disabled]="reasonForm.invalid"
      >
        Submit
      </button>
      <button class="btn btn-secondary" (click)="modal.dismiss('cancel')">
        Cancel
      </button>
    </div>
  </form>
</ng-template>

<!--------------------------------- View popup --------------------------------->

<ng-template #pdfViewer let-offcanvas>
  <div class="offcanvas-header">
    <h2 class="modal-title mt-2">EOC Document</h2>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="offcanvas.dismiss()"
    ></button>
  </div>
  <div class="offcanvas-body">
    <iframe
      *ngIf="pdfDataUrl"
      [src]="pdfDataUrl"
      width="100%"
      height="100%"
      frameborder="0"
    ></iframe>
    <img *ngIf="imageDataUrl" [src]="imageDataUrl" width="100%" />
    <div *ngIf="!pdfDataUrl && !imageDataUrl">Loading...</div>
  </div>
</ng-template>

<app-loader *ngIf="isLoading"></app-loader>
